import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const prepareSearchSchema = z.object({
  // Present when editing a sent-back review: prefills the form and resubmits instead of creating.
  reviewId: z.number().optional(),
})

// Preparing a CLR is no longer its own page but a drawer on the customer overview. This route
// stays only so bookmarked prepare links still land in the right place, reviewId and all.
export const Route = createFileRoute('/_auth/_modules/credit/customers/$erp/prepare-clr')({
  validateSearch: prepareSearchSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/credit/customers/$erp',
      params,
      search: { prepareClr: true, reviewId: search.reviewId },
    })
  },
})
